import { ReactNode } from 'react';
import { IIcons, Loader, SvgIcon } from '@ascd/witsby-components';
import { Box, IconButton } from '@mui/material';

interface IAdminDashboardCommonCard {
  title?: string;
  loading?: boolean;
  children: ReactNode;
  onTitleClick?: () => void;
  onExtrasClick?: () => void;
  titleIconViewBox?: string;
  minHeight?: string | number;
  maxHeight?: string | number;
  titleIcon?: keyof IIcons | string;
}

const AdminDashboardCommonCard = ({
  title,
  loading,
  children,
  titleIcon,
  maxHeight,
  onTitleClick,
  onExtrasClick,
  minHeight = 250,
  titleIconViewBox = '0 0 24 24',
}: IAdminDashboardCommonCard) => (
  <Box
    data-testid={`${title?.split(' ').join('-')}`}
    sx={{
      maxHeight,
      minHeight,
      height: '100%',
      boxShadow: '0px 3px 8px 2px rgba(0, 0, 0, 0.14)',
      borderRadius: (theme) => theme.border.radius.X_LARGE,
    }}>
    <Box
      sx={{
        p: 2,
        height: 'calc(100% - 32px)',
      }}>
      {loading ? (
        <Loader isFullScreen />
      ) : (
        <>
          {(title || titleIcon) && (
            <Box
              onClick={() => {
                if (onTitleClick) onTitleClick();
              }}
              sx={{
                mb: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                ...(onTitleClick && {
                  cursor: 'pointer',
                }),
              }}>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                {titleIcon && (
                  <SvgIcon
                    icon={titleIcon}
                    viewBox={titleIconViewBox}
                    sx={(theme) => ({
                      mr: 1.5,
                      fontSize: theme.font.size.H6,
                      fill: theme.palette.primary.main,
                      color: theme.palette.primary.main,
                      '& path': {
                        fill: theme.palette.primary.main,
                      },
                    })}
                  />
                )}
                <Box
                  sx={(theme) => ({
                    color: theme.palette.grey[200],
                    fontSize: theme.font.size.REGULAR,
                    fontWeight: theme.font.weight.BOLD,
                  })}>
                  {title}
                </Box>
              </Box>
              {onExtrasClick && (
                <Box>
                  <IconButton
                    sx={{ p: 0 }}
                    onClick={() => onExtrasClick()}
                    aria-label="Handle graph">
                    <SvgIcon
                      icon="CLICK_ICON"
                      sx={(theme) => ({
                        cursor: 'pointer',
                        fill: theme.palette.primary.main,
                        fontSize: theme.font.size.REGULAR,
                      })}
                    />
                  </IconButton>
                </Box>
              )}
            </Box>
          )}
          <Box sx={{ height: 'calc(100% - 35px)' }}>{children}</Box>
        </>
      )}
    </Box>
  </Box>
);

export default AdminDashboardCommonCard;
